import { combineReducers } from 'redux';
import { modalReducer } from '@state/slices/modal/modalSlice';
import { loadingReducer } from './loading';
import { pathReducer } from './routing';
import { historyReducer } from './history';
import { destinationReducer } from './destination';
import { cmsConfigIdReducer } from './cms-config-id';
import { packageReferencesReducer } from './package-references';
import { promoModalReducer } from './promo-modal';
import { shareLinkReducer } from './share-link';
import { paymentErrorReducer } from './payment-error';
import { uiStateReducer } from './ui-state';

export const combinedAppReducers = combineReducers({
  destination: destinationReducer,
  path: pathReducer,
  history: historyReducer,
  modal: modalReducer,
  loading: loadingReducer,
  cmsConfigId: cmsConfigIdReducer,
  packageReferences: packageReferencesReducer,
  promoModal: promoModalReducer,
  shareLink: shareLinkReducer,
  paymentError: paymentErrorReducer,
  uiState: uiStateReducer
});

export type CombinedAppReducersType = ReturnType<typeof combinedAppReducers>;
